import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { regenerateWorkspaceCode } from '../../../../api/workspaces/invite/regenerateWorkspaceCode';

export function useRegenerateWorkspaceCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: regenerateWorkspaceCode,
    onSettled: (_data, _error, { workspaceId, workspaceRole }) => {
      queryClient.invalidateQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
      // Keep the dropdown status badges in sync (a reset still leaves the link
      // active, but this guards against the badge drifting from reality).
      return queryClient.invalidateQueries(
        workspaceKeys.codeStatuses(workspaceId)
      );
    },
    onMutate: ({ workspaceId, workspaceRole }) => {
      queryClient.removeQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
  });
}
